import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

export const getPaidColumnHtml = (isPaid: boolean) => {
    if (isPaid) {
        return (
            <b>
                <i className='green-text'>
                    <FontAwesomeIcon icon={faCheck} />
                </i>
            </b>
        );
    } else {
        return (
            <b>
                <i className='red-text'>
                    <FontAwesomeIcon icon={faTimes} />
                </i>
            </b>
        );
    }
};
